<div class="ui-product-list">
  <article
    class="ui-card ui-prow"
    *ngFor="let product of products"
    [class.is-out]="!product?.ProductStocks"
  >
    <div class="ui-thumb ui-prow__thumb" *ngIf="product?.ProductImageUrl">
      <img
        [src]="product?.ProductImageUrl"
        [alt]="product?.ProductTitle"
        loading="lazy"
        decoding="async"
        (click)="getProductModal(product)"
      />
    </div>

    <div class="ui-prow__main">
      <div class="ui-prow__head">
        <div class="ui-prow__title">{{ product?.ProductTitle }}</div>
        <button
          type="button"
          class="ui-btn ui-btn--ghost ui-btn--sm ui-btn--icon ui-prow__fav"
          [class.is-on]="product.IsFavourite"
          [attr.aria-label]="product.IsFavourite ? 'Remove from favourites' : 'Add to favourites'"
          [attr.aria-pressed]="!!product.IsFavourite"
          (click)="addRemoveFavourite(product, !product.IsFavourite)"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M12 20.5s-7.5-4.6-9.4-9.1C1.3 8.2 3.4 4.5 7 4.5c2 0 3.4 1.1 4.2 2.4h1.6C13.6 5.6 15 4.5 17 4.5c3.6 0 5.7 3.7 4.4 6.9-1.9 4.5-9.4 9.1-9.4 9.1z"
            />
          </svg>
        </button>
      </div>

      <div class="ui-prow__meta">
        <b class="ui-prow__price" *ngIf="product?.ProductOldPrice">
          {{ product?.ProductOldPrice | currency: CurrencySymbol : "symbol" : "1.2-2" }}
          <small>/ {{ product?.ProductUnits }}</small>
        </b>
        <span class="ui-tag ui-tag--danger" *ngIf="!product?.ProductStocks">
          Out of stock
        </span>
        <span class="ui-badge ui-badge--sm ui-prow__inbasket" *ngIf="product.ProductQuantity && hasOptions(product)">
          {{ inBasket(product) }} in basket
        </span>
      </div>

      <div class="ui-prow__foot">
        <div class="ui-prow__add" *ngIf="!product.ProductQuantity || hasOptions(product)">
          <button
            type="button"
            class="ui-btn ui-btn--sm"
            [disabled]="!product?.ProductStocks"
            (click)="getProductModal(product)"
          >
            {{ product.ProductQuantity ? "Add another" : "Add to cart" }}
          </button>
        </div>

        <div
          class="ui-qty ui-qty--mini"
          *ngIf="
            product.ProductQuantity && !hasOptions(product) &&
            (PopupOnKgItems ? !(product.ProductUnits.toLowerCase() == 'kg') : true)
          "
        >
          <button type="button" aria-label="Decrease quantity" (click)="quantityControl(product, '-')">−</button>
          <span>{{ product?.ProductQuantity }}</span>
          <button type="button" aria-label="Increase quantity" (click)="quantityControl(product, '+')">+</button>
        </div>

        <span class="ui-select" *ngIf="
              product.ProductQuantity && !hasOptions(product) &&
              (PopupOnKgItems ? product.ProductUnits.toLowerCase() == 'kg' : false)
            ">

          <select
            class="ui-input ui-prow__kg"
            name="kgList"
            aria-label="Weight"            
            [ngModel]="+product.ProductQuantity"
          (ngModelChange)="product.ProductQuantity = $event; kgListChanged(product)"
            [compareWith]="sameQty"
          >
          <option *ngFor="let w of kgChoices(product.ProductQuantity)" [ngValue]="w">{{ w | number : "1.1-1" }} kg</option>
        </select>

        </span>
      </div>
    </div>
  </article>
</div>

<ngx-spinner [bdColor]="spinnerBackdrop" size="large" [color]="spinnerColor" type="ball-scale-multiple">
</ngx-spinner>
